import { getRequest } from ".";

export const getOrderlordStores = async (params?: Record<string, unknown>) => {
    const response = await getRequest('api/orderlord/stores', params) as any;
    const {data, limit, offset, total} = response;
    return {data, limit, offset, total};
}